import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from 'react-redux';
import { Button } from "@material-ui/core";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LOGOUT_REQUEST } from "./../redux/types"
import './menu.css'


const Menu = ({ isMobile, height, closeNav, setCloseNav }) => {
    const { user: { userData } } = useSelector(state => state)
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation()
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (isMobile) {
            setCloseNav(true)
        }
        else {
            setCloseNav(false)
        }
    }, [isMobile])

    useEffect(() => {
        const onClick = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target) && e.target.id != "header-bar") {
                setCloseNav(true);
            }
        };
        if (isMobile) {
            window.addEventListener("click", onClick);
        }

        return () => {
            window.removeEventListener("click", onClick);
        };
    }, [isMobile, dropdownRef]);

    useEffect(() => {
        if (isMobile) {
            setCloseNav(true);
        }
    }, [location, isMobile])

    const Logout = (e) => {
        dispatch({ type: LOGOUT_REQUEST })
        navigate("login")
    }

    return (
        isMobile ? <><header className="app-bar" id="header-bar">
            <div className="header-bar" id="header-bar">
                <div style={{ marginTop: '0' }}>
                    <h1 style={{ textAlign: 'start', fontSize: '25px', fontWeight: 600, marginLeft: '16px', marginRight: '16px' }}><span style={{ color: '#6ab23a' }}>HR</span> Com<span style={{ color: '#6ab23a' }}>7</span></h1>
                    <h2 style={{ textAlign: 'start', fontSize: '18px', fontWeight: 600, marginTop: '-16px', marginLeft: '16px', marginRight: '24px' }}>Documentary</h2>
                </div>
                <Button id="header-bar" onClick={() => setCloseNav((old) => !old)} style={{ borderRadius: '50%', height: '48px', width: '48px' }}>
                    <div className="btn_content" id="header-bar">
                        <i id="header-bar" className='bx bx-menu' style={{ height: '24px', width: '24px', fontSize: '24px' }} />
                    </div>
                </Button>
            </div>
            <div className="header-line" cols='12'></div>
        </header>
            <nav ref={dropdownRef} className={`sidebar ${closeNav ? 'closeZ' : ''}`}
                style={{ position: 'sticky', height: height > 100 ? 'auto' : '', }}
            // style={{ position: 'sticky', height: '100%', overflow: 'hidden' }}
            >
                {!closeNav && <Button id="header-bar" onClick={() => setCloseNav((old) => !old)} style={{ borderRadius: '50%', height: '48px', width: !isMobile ? 0 : '100%', justifyContent: !isMobile ? 0 : 'flex-end', alignItems: !isMobile ? 0 : 'flex-end' }}>
                    <div className="btn_content" id="header-bar">
                        <i id="header-bar" className='bx bx-menu' style={{ height: '24px', width: '24px', fontSize: '24px' }} />
                    </div>
                </Button>}
                {!closeNav && <div className="userinfo">
                    <div className="row user-content align-center justify-center">
                        <div className="col">
                            <div className="row layout">
                                <div className="" cols='12' style={{ backgroundColor: '#6C757D40', width: '100%', height: '1px', marginBottom: '10%', marginTop: '3%' }}></div>
                                <div className="" cols='12' style={{ textAlign: 'center', fontWeight: 600, width: '100%', fontSize: '25px' }}>{userData?.fullname}</div>
                                <div className="" cols='12' style={{ textAlign: 'center', fontWeight: 400, width: '100%', fontSize: '.9rem' }}>{userData?.PositionName}</div>
                                <div className="" cols='12' style={{ textAlign: 'center', fontWeight: 400, width: '100%', fontSize: '.9rem' }}><span style={{ color: '' }}>รหัสพนักงาน:</span> {userData?.username}</div>
                                <div className="" cols='12' style={{ textAlign: 'center', fontWeight: 400, width: '100%', fontSize: '.9rem' }}><span style={{ color: '' }}>อีเมล:</span> {userData.email ? userData.email : "Email : '-' "}</div>
                                <div className="" cols='12' style={{ textAlign: 'center', fontWeight: 400, width: '100%', fontSize: '.9rem', margin: 'auto', marginTop: '10px' }}><Link to="edit_profile" style={{ textDecoration: 'none' }}><Button style={{ border: '1px solid #6ab23a', textTransform: 'none', color: '#6ab23a', marginTop: '5px', borderRadius: '24px', padding: '8px 16px', }}>Edit Profile</Button></Link></div>
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="menu-bar">
                    <div className="menu">
                        <ul className="menu-links">
                            <li className="nav-link" style={{ border: location?.pathname.includes("/document") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="document">
                                    <i className="bx bx bxs-file-pdf icon" />
                                    <span className="text nav-text">ขอเอกสาร</span>
                                </Link>
                            </li>
                            {(userData?.permission?.manage_contract) && <li className="nav-link" style={{ border: location?.pathname.includes("/export_docs") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="export_docs">
                                    <i className="bx bx bxs-file-pdf icon" />
                                    <span className="text nav-text">ออกเอกสาร</span>
                                </Link>
                            </li>}
                            {(userData?.permission?.add_type || userData?.permission?.edit_type) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-type") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="manage-type">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">จัดการ Type</span>
                                </Link>
                            </li>}
                            {(userData?.permission?.add_prefix || userData.permission?.edit_prefix) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-prefix") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="manage-prefix">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">จัดการ Prefix</span>
                                </Link>
                            </li>}
                            {(userData?.permission?.manage_pdpa) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-pdpa") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="manage-pdpa">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">จัดการ PDPA</span>
                                </Link>
                            </li>}
                             {(userData?.permission?.manage_acceptable_use) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-acceptable-use") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="manage-acceptable-use">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">จัดการ Acceptable Use</span>
                                </Link>
                            </li>}
                            {(userData?.permission?.detail_user) && <li className="nav-link" style={{ border: location?.pathname.includes("/user-detail") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="user-detail">
                                    <i className="bx bx-user icon" />
                                    <span className="text nav-text">ค้นหา User</span>
                                </Link>
                            </li>}
                            <li className="nav-link" style={{ border: location?.pathname.includes("/pdpa") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="pdpa">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">PDPA</span>
                                </Link>
                            </li>
                             <li className="nav-link" style={{ border: location?.pathname.includes("/acceptable-use") ? "0.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="acceptable-use">
                                    <i className="bx bx-edit-alt icon" />
                                    <span className="text nav-text">Acceptable Use</span>
                                </Link>
                            </li>
                            <li style={{ cursor: 'pointer' }}>
                                <div onClick={Logout}>
                                    <i className="bx bx-log-out icon" />
                                    <span className="text nav-text">Logout</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </> : <nav className={`sidebar ${closeNav ? 'close' : ''}`} style={{ position: 'sticky', backgroundColor: '#F8F9FA', overflowY: 'auto' }}>
            <div style={{ marginTop: '4%' }}>
                <h1 style={{ textAlign: 'start', fontSize: '38px', fontWeight: 600, marginLeft: '16px', marginRight: '16px' }}><span style={{ color: '#6ab23a' }}>HR</span> Com<span style={{ color: '#6ab23a' }}>7</span></h1>
                <h2 style={{ textAlign: 'start', fontSize: '25px', fontWeight: 600, marginTop: '-16px', marginLeft: '16px', marginRight: '24px' }}>Documentary</h2>
            </div>
            <div className="menu-bar">
                <div className="menu" >
                    <ul className="menu-links">
                        <li className="nav-link" style={{ border: location?.pathname.includes("/document") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="document">
                                <i className="bx bxs-file-pdf icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">ขอเอกสาร</span>
                            </Link>
                        </li>
                        {(userData?.permission?.manage_contract) &&
                            <li className="nav-link" style={{ border: location?.pathname.includes("/export_docs") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                                <Link to="export_docs">
                                    <i className="bx bx bxs-file-pdf icon" style={{ marginTop: '0' }} />
                                    <span className="text nav-text">ออกเอกสาร</span>
                                </Link>
                            </li>
                        }
                        {(userData?.permission?.add_type || userData?.permission?.edit_type) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-type") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="manage-type">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">จัดการประเภทเอกสาร</span>
                            </Link>
                        </li>}
                        {(userData?.permission?.add_prefix || userData?.permission?.edit_prefix) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-prefix") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="manage-prefix">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">จัดการ Prefix</span>
                            </Link>
                        </li>}
                        {(userData?.permission?.manage_pdpa) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-pdpa") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="manage-pdpa">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">จัดการ PDPA</span>
                            </Link>
                        </li>}
                          {(userData?.permission?.manage_acceptable_use) && <li className="nav-link" style={{ border: location?.pathname.includes("/manage-acceptable-use") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="manage-acceptable-use">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">จัดการ Acceptable Use</span>
                            </Link>
                        </li>}
                        {(userData?.permission?.detail_user) && <li className="nav-link" style={{ border: location?.pathname.includes("/user-detail") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="user-detail">
                                <i className="bx bx-user icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">ค้นหา User</span>
                            </Link>
                        </li>}
                        <li className="nav-link" style={{ border: location?.pathname.includes("/pdpa") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="pdpa">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">PDPA</span>
                            </Link>
                        </li>
                         <li className="nav-link" style={{ border: location?.pathname.includes("/acceptable-use") ? "1.5px solid #6ab23a" : "none", borderRadius: '5px' }}>
                            <Link to="acceptable-use">
                                <i className="bx bx-edit-alt icon" style={{ marginTop: '0' }} />
                                <span className="text nav-text">Acceptable Use</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <header className="col-header" style={{ marginTop: '-40%' }}>
                <div className="userinfo">
                    <div className="row user-content align-center justify-center" style={{ backgroundColor: '#F8F9FA' }}>
                        <div className="col">
                            <div className="row layout">
                                <div className="" cols='12' style={{ backgroundColor: '#6C757D40', width: '100%', height: '1px', marginLeft: '24px', marginBottom: '10%', marginRight: '24px' }}></div>
                                <div className="" cols='12' style={{ textAlign: 'start', fontWeight: 600, width: '100%', fontSize: '25px', marginLeft: '24px', marginRight: '24px' }}>{userData?.fullname}</div>
                                <div className="" cols='12' style={{ textAlign: 'start', fontWeight: 600, width: '100%', fontSize: '.9rem', marginLeft: '24px', marginRight: '24px', marginTop: '4px' }}>{userData?.PositionName}</div>
                                <div className="" cols='12' style={{ textAlign: 'start', fontWeight: 600, width: '100%', fontSize: '.9rem', marginLeft: '24px', marginRight: '24px' }}><span style={{ color: '#6C757D' }}>รหัสพนักงาน:</span> {userData?.username}</div>
                                <div className="" cols='12' style={{ textAlign: 'start', fontWeight: 600, width: '100%', fontSize: '.9rem', marginLeft: '24px', marginRight: '24px' }}><span style={{ color: '#6C757D' }}>อีเมล:</span> {userData.email ? userData.email : "Email : '-' "}</div>
                                <div className="" cols='12' style={{ textAlign: 'start', fontWeight: 600, width: '100%', fontSize: '.9rem', marginLeft: '24px', marginTop: '8px' }}><Link to="edit_profile" style={{ textDecoration: 'none' }}>
                                    {!closeNav ? <Button style={{ border: '1px solid #6ab23a', textTransform: 'none', color: '#6ab23a', marginTop: '5px', borderRadius: '24px', padding: '8px 16px', marginBottom: '16px' }}>แก้ไข ข้อมูลส่วนตัว </Button> : <i className="bx bx-edit icon" style={{ color: '#F8F9FA', marginTop: '5px' }} />}
                                </Link></div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <i className="bx bx-chevron-right toggle" onClick={() => setCloseNav((old) => !old)} /> */}
            </header>
            <div className="bottom-content">
                <li style={{ cursor: 'pointer' }}>
                    <div onClick={Logout}>
                        <i className="bx bx-log-out icon" style={{ marginTop: '0' }} />
                        <span className="text nav-text">ออกจากระบบ</span>
                    </div>
                </li>
            </div>
        </nav>
    )

}

export default Menu
